<div class="modal-overlay">
  <div class="modal">
    <div class="modal-header">
      <div class="h7">Add Location</div>
      <button class="close-button" (click)="closeModal()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="tabs">
        <div class="tab p5" [class.active]="activeTab === 'Address'" (click)="setTab('Address')">
          <img
            *ngIf="form.get('address')?.valid"
            src="assets/images/circle-check-filled.svg"
            alt="Address"
            class="tab-icon"
          />
          <span *ngIf="!form.get('address')?.valid" class="tab-number">1</span>

          <span class="tab-label">Address</span>
        </div>
        <div
          class="tab p5"
          [class.active]="activeTab === 'Contact Details'"
          (click)="setTab('Contact Details')"
        >
          <img
            *ngIf="form.get('contactDetails')?.valid"
            src="assets/images/circle-check-filled.svg"
            alt="Contact Details"
            class="tab-icon"
          />
          <span *ngIf="!form.get('contactDetails')?.valid" class="tab-number">2</span>
          <span class="tab-label">Contact Details</span>
        </div>
        <div
          class="tab p5"
          [class.active]="activeTab === 'Operating Hours'"
          (click)="setTab('Operating Hours')"
        >
          <img
            *ngIf="form.get('address')?.valid && form.get('contactDetails')?.valid"
            src="assets/images/circle-check-filled.svg"
            alt="Operating Hours"
            class="tab-icon"
          />
          <span
            *ngIf="!(form.get('address')?.valid && form.get('contactDetails')?.valid)"
            class="tab-number"
            >3</span
          >
          <span class="tab-label">Operating Hours</span>
        </div>
      </div>
      <div class="tab-content" [formGroup]="form">
        <div *ngIf="activeTab === 'Address'" formGroupName="address" class="form-contain">
          <div class="address-columns">
            <div class="address-column">
              <div class="form-group">
                <label for="locationName"
                  >Location / Branch Name<span class="required">*</span></label
                >
                <input
                  id="locationName"
                  placeholder="e.g. Harlem"
                  type="text"
                  formControlName="branch"
                  class="form-control"
                  maxlength="100"
                />
                <div
                  *ngIf="
                    addressForm.get('branch')?.invalid &&
                    (addressForm.get('branch')?.dirty || addressForm.get('branch')?.touched)
                  "
                  class="error-message"
                >
                  <div
                    class="error-message"
                    *ngIf="addressForm.get('branch')?.errors?.['required']"
                  >
                    Location name is required.
                  </div>
                  <div *ngIf="addressForm.get('branch')?.errors?.['standardName']">
                    {{ addressForm.get('branch')?.errors?.['standardName']?.message }}
                  </div>
                  <div *ngIf="addressForm.get('branch')?.errors?.['maxlength']">
                    Location name cannot exceed 100 characters.
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="city">City<span class="required">*</span></label>
                <input
                  id="city"
                  placeholder="e.g. New York City"
                  type="text"
                  formControlName="city"
                  class="form-control"
                  maxlength="100"
                />
                <div
                  *ngIf="
                    addressForm.get('city')?.invalid &&
                    (addressForm.get('city')?.dirty || addressForm.get('city')?.touched)
                  "
                  class="error-message"
                >
                  <div *ngIf="addressForm.get('city')?.errors?.['required']">City is required.</div>
                  <div *ngIf="addressForm.get('city')?.errors?.['cityState']">
                    {{ addressForm.get('city')?.errors?.['cityState']?.message }}
                  </div>
                  <div *ngIf="addressForm.get('city')?.errors?.['maxlength']">
                    City cannot exceed 100 characters.
                  </div>
                </div>
              </div>
              <div class="form-group country-select">
                <label for="country">Country<span class="required">*</span></label>
                <div class="dropdown" style="pointer-events: none">
                  <mat-select
                    id="country"
                    formControlName="country"
                    placeholder="Select a country"
                    [disabled]="true"
                    class="form-control"
                  >
                    <mat-option *ngFor="let country of countries" [value]="country.name">
                      {{ country.name }}
                    </mat-option>
                  </mat-select>
                </div>
                <div
                  *ngIf="
                    addressForm.get('country')?.invalid &&
                    (addressForm.get('country')?.dirty || addressForm.get('country')?.touched)
                  "
                  class="error-message"
                >
                  <div *ngIf="addressForm.get('country')?.errors?.['required']">
                    Country is required.
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="timezone">Time Zone<span class="required">*</span></label>
                <div class="select-wrapper p-custom-select">
                  <mat-select id="timezone" class="form-select" formControlName="timezone">
                    <mat-option value="">Select time zone</mat-option>
                    <mat-option *ngFor="let tz of timezones" [value]="tz.value">
                      {{ tz.label }}
                    </mat-option>
                  </mat-select>
                </div>
                <div
                  *ngIf="
                    addressForm.get('timezone')?.invalid &&
                    (addressForm.get('timezone')?.dirty || addressForm.get('timezone')?.touched)
                  "
                  class="error-message"
                >
                  <div *ngIf="addressForm.get('timezone')?.errors?.['required']">
                    Time zone is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="address-column">
              <div class="form-group">
                <label for="streetAddress">Street Address<span class="required">*</span></label>
                <input
                  id="streetAddress"
                  placeholder="e.g. Door 112 B, 5th Avenue"
                  type="text"
                  formControlName="street_address"
                  class="form-control"
                  maxlength="200"
                />
                <div
                  *ngIf="
                    addressForm.get('street_address')?.invalid &&
                    (addressForm.get('street_address')?.dirty ||
                      addressForm.get('street_address')?.touched)
                  "
                  class="error-message"
                >
                  <div *ngIf="addressForm.get('street_address')?.errors?.['required']">
                    Street address is required.
                  </div>
                  <div *ngIf="addressForm.get('street_address')?.errors?.['maxlength']">
                    Street address cannot exceed 200 characters.
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="state">State<span class="required">*</span></label>
                <div class="select-wrapper p-custom-select">
                  <mat-select id="state" class="form-select" formControlName="state">
                    <mat-option value="">Select State</mat-option>
                    <mat-option *ngFor="let state of states" [value]="state.name">
                      {{ state.name }}
                    </mat-option>
                  </mat-select>
                </div>
                <div
                  *ngIf="
                    addressForm.get('state')?.invalid &&
                    (addressForm.get('state')?.dirty || addressForm.get('state')?.touched)
                  "
                  class="error-message"
                >
                  <div *ngIf="addressForm.get('state')?.errors?.['required']">
                    State/Province is required.
                  </div>
                  <div *ngIf="addressForm.get('state')?.errors?.['cityState']">
                    {{ addressForm.get('state')?.errors?.['cityState']?.message }}
                  </div>
                  <div *ngIf="addressForm.get('state')?.errors?.['maxlength']">
                    State cannot exceed 50 characters.
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="zip">Zip Code<span class="required">*</span></label>
                <input
                  id="zip"
                  placeholder="e.g. 1001"
                  type="text"
                  formControlName="zip_code"
                  class="form-control"
                  maxlength="10"
                />
                <div
                  *ngIf="
                    addressForm.get('zip_code')?.invalid &&
                    (addressForm.get('zip_code')?.dirty || addressForm.get('zip_code')?.touched)
                  "
                  class="error-message"
                >
                  <div *ngIf="addressForm.get('zip_code')?.errors?.['required']">
                    Zip code is required.
                  </div>
                  <div *ngIf="addressForm.get('zip_code')?.errors?.['usaZipCode']">
                    {{ addressForm.get('zip_code')?.errors?.['usaZipCode']?.message }}
                  </div>
                  <div *ngIf="addressForm.get('zip_code')?.errors?.['maxlength']">
                    ZIP Code cannot exceed 10 characters.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="activeTab === 'Contact Details'"
          formGroupName="contactDetails"
          class="form-container"
        >
          <div class="form-row conatct-row">
            <div class="form-group">
              <label for="email">Email<span class="required">*</span></label>
              <input
                type="email"
                placeholder="e.g. johnsmith@example.com"
                id="email"
                formControlName="email"
                class="form-control"
                maxlength="254"
              />
              <div
                *ngIf="
                  contactDetailsForm.get('email')?.invalid &&
                  (contactDetailsForm.get('email')?.dirty ||
                    contactDetailsForm.get('email')?.touched)
                "
                class="error-message"
              >
                <div *ngIf="contactDetailsForm.get('email')?.errors?.['required']">
                  Email is required.
                </div>
                <div *ngIf="contactDetailsForm.get('email')?.errors?.['strictEmail']">
                  Please enter a valid email address.
                </div>
                <div *ngIf="contactDetailsForm.get('email')?.errors?.['maxlength']">
                  Email cannot exceed 254 characters.
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="phone">Phone Number<span class="required">*</span></label>
              <input
                type="tel"
                placeholder="e.g. (123) 456 7890"
                id="phone"
                formControlName="contact"
                class="form-control"
                maxlength="15"
              />
              <div
                *ngIf="
                  contactDetailsForm.get('contact')?.invalid &&
                  (contactDetailsForm.get('contact')?.dirty ||
                    contactDetailsForm.get('contact')?.touched)
                "
                class="error-message"
              >
                <div *ngIf="contactDetailsForm.get('contact')?.errors?.['required']">
                  Phone number is required.
                </div>
                <div *ngIf="contactDetailsForm.get('contact')?.errors?.['usaPhone']">
                  Please enter a valid phone number.
                </div>
                <div *ngIf="contactDetailsForm.get('contact')?.errors?.['maxlength']">
                  Phone number cannot exceed 15 characters.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="activeTab === 'Operating Hours'"
          class="operating-hours-container form-container"
          formArrayName="operatingHours"
        >
          <div class="copy-hours-section">
            <div>
              <p class="title">Copy hours from another location</p>
              <p class="description">Quickly apply existing hours from any of your location.</p>
            </div>
            <div class="actions">
              <div class="dropdown"></div>
              <button
                class="btn btn-outlined btn-small"
                [ngClass]="{ disabled: !selectedLocation }"
                (click)="applyHours()"
              >
                <img
                  *ngIf="hoursApplied"
                  src="assets/images/package/check.svg"
                  alt="Applied"
                  class="applied-icon"
                />
                {{ hoursApplied ? 'Applied' : 'Apply Hours' }}
              </button>
            </div>
          </div>
          <div class="days-container">
            <div
              class="day-row"
              *ngFor="let day of days; let i = index; trackBy: trackByIndex"
              [formGroupName]="i"
            >
              <div class="day-name" [ngClass]="{ 'text-disabled': !day.isOpen }">
                {{ day.name }}
              </div>
              <div class="status-toggle">
                <label class="switch">
                  <input type="checkbox" formControlName="isOpen" (change)="onToggleDay(day, i)" />
                  <span class="slider round"></span>
                </label>
                <span class="status-label">{{ day.isOpen ? 'Open' : 'Closed' }}</span>
              </div>
              <div class="time-inputs" [class.disabled]="!day.isOpen">
                <div class="dropdown"></div>
                <div class="time-separator">-</div>
                <div class="dropdown"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div>
        <button
          class="btn btn-tertiary btn-medium"
          (click)="backTab()"
          *ngIf="activeTab !== 'Address'"
        >
          Back
        </button>
      </div>
      <div>
        <button class="btn btn-secondary btn-medium" (click)="closeModal()">Cancel</button>
        <button
          class="btn btn-primary btn-medium"
          *ngIf="activeTab !== 'Operating Hours'"
          (click)="nextTab()"
          [ngClass]="{ disabled: isNextButtonDisabled() }"
          [disabled]="isNextButtonDisabled()"
        >
          Continue
        </button>
        <button
          class="btn btn-primary btn-medium"
          *ngIf="activeTab === 'Operating Hours'"
          (click)="saveLocation()"
          [ngClass]="{ disabled: !form.valid }"
          [disabled]="!form.valid"
        >
          Save Location
        </button>
      </div>
    </div>
  </div>
</div>
